module.exports = __webpack_public_path__ + "static/img/7.ec82622.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/7.png
// module id = nt9M
// module chunks = 4